import React, {useState} from "react";
import {Button, EditButton, translate,} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SendIcon from "@material-ui/icons/Send";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axios";
import env from "../../env";
import {showErrorNotify, showSuccessNotify} from "../../components";

const ShowFooterActions = ({record, basePath}) => {
    const [loading, setLoading] = useState(false);
    if (!record) return null;

    const isDraft = record.status === "DRAFT";
    const haveRefund = record.purchaseCount > 0;
    const confirmSendReview = () => {
        Swal.fire({
            title: "Bạn chắc chắn muốn gửi duyệt?",
            text: "",
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        })
            .then((result) => {
                if (result.value) {
                    setLoading(true)
                    axiosInstance.put(`/api/purchaseCancelRequests/send-review/${record.id}`, {}, {
                        newBaseUrl: env.kiotUrl,
                    }).then((res) => {
                        setLoading(false)
                        if (res?.data?.success) {
                            showSuccessNotify("Gửi duyệt thành công")
                            window.location.href = "#/purchaseCancelRequests";
                        } else {
                            showErrorNotify("Gửi duyệt không thành công")
                        }
                    })
                        .catch(err => {
                            setLoading(false)
                            showErrorNotify(err.message)
                        })
                }
            });
    }
    return (
        <div style={{marginTop: 24, display: "flex", gap: 12}}>
            <Button
                label="Quay lại"
                onClick={() => window.history.back()}
                disabled={loading}
            >
                <ArrowBackIcon/>
            </Button>

            {isDraft && haveRefund && (
                <Button
                    label="Gửi duyệt"
                    onClick={confirmSendReview}
                    style={{color: "#37662d"}}
                    disabled={loading}
                    loading={loading}
                >
                    <SendIcon/>
                </Button>
            )}
            {isDraft &&
                <EditButton basePath={basePath} record={record} disabled={loading}/>
            }
        </div>
    );
};

export default translate(ShowFooterActions);
